(() => {
  angular
    .module('gm.common.ui')
    .directive('gmyReloadButton', gmyReloadButton);

  function gmyReloadButton(
    $window
  ) {
    'ngInject';

    return {
      restrict: 'A',
      link(scope, element) {
        function clickHandler(event) {
          event.preventDefault();
          $window.location.reload();
        }

        function onDestroy() {
          element.off('click', clickHandler);
        }

        element.on('click', clickHandler);
        scope.$on('$destroy', onDestroy);
      }
    };
  }
})();
